// @flow

import Resource from 'speed-js-core/src/api/NestedResource';

export default class OrganisationRepresentativeResource extends Resource {
    basePath: string = 'entities/organisations/{parent}/representatives/';

    objectPath: string = 'entities/organisations/{parent}/representatives/{ident}/';
}
